import { render, staticRenderFns } from "./PublishersList.vue?vue&type=template&id=05624e64&scoped=true&"
import script from "./PublishersList.vue?vue&type=script&lang=js&"
export * from "./PublishersList.vue?vue&type=script&lang=js&"
import style0 from "./PublishersList.vue?vue&type=style&index=0&id=05624e64&scoped=true&lang=scss&"
import style1 from "./PublishersList.vue?vue&type=style&index=1&id=05624e64&lang=scss&scoped=true&"
import style2 from "./PublishersList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05624e64",
  null
  
)

export default component.exports